import React, { Fragment } from "react";
import {useSelector} from "react-redux";
import ChannelCard from "../../Utilities/ChannelCard";
import logoTrustpilot from "../../../../../images/logos/logo_trustpilot.svg";
import useTrustpilotSetup from "./useTrustpilotSetup";
import DataSourceWebhookModal from "../../Utilities/DataSourceWebhookModal";
import TrustpilotAppModal from "./TrustpilotAppModal";

export default function TrustpilotProvider() {
    const trustpilot = useSelector((state) => state.trustpilotAuth)
    const {
        initiateTrustpilotSetup,
        trustpilotSetupOpen,
        handleTrustpilotSetupClose,
        handleTrustpilotSetupOpen,
        redirectUrl
    } = useTrustpilotSetup({ callbackPath: '/trustpilot/accounts' });

    return(
        <Fragment>
            <ChannelCard
                icon={logoTrustpilot}
                label={'Trustpilot'}
                description={'Respond to customer reviews'}
                onClick={initiateTrustpilotSetup}
            />

            <TrustpilotAppModal
                open={trustpilotSetupOpen}
                handleOpen={handleTrustpilotSetupOpen}
                handleClose={handleTrustpilotSetupClose}
                redirectUrl={redirectUrl}
            />

            <DataSourceWebhookModal
                showWebhookUrl={trustpilot?.showWebhookUrl}
                webhookUrl={trustpilot?.webhookUrl}
                platformUrl={trustpilot?.platformUrl}
                dataSourceName={'Trustpilot'}
            />
        </Fragment>
    )
}